<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="导出报表"
      :innerHeight="'auto'"
      width="400px"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <!-- // 业务 -->
      <el-form :inline="true">
        <el-form-item label="">
          <el-checkbox v-model="checked" :disabled="checkList.indexOf(1) === -1">带图片</el-checkbox>
        </el-form-item>
        <el-form-item label="">
          <el-checkbox-group v-model="checkList" @change="handleCheckList">
            <el-checkbox :label="1">SPU</el-checkbox>
            <el-checkbox :label="2">SKU</el-checkbox>
            <el-checkbox :label="3">产品</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div class="tips">有图片最多导出200条，无图片不限制；</div>
    </q-dialog>
  </div>
</template>

<script>
import moment from "moment";
export default {
  model: {
    prop: "visible",
    event: "input",
  },
  props: ["visible", "formData"],
  data() {
    return {
      dialogVisible: false,
      // 业务
      checked: false,
      checkList: [],
    };
  },
  mounted() {
    this.dialogVisible = this.visible;
    // 业务
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout((_) => {
        this.$emit("input", false);
      }, 200);
    },
    confirm() {
      this.exportExcel();
    },
    // 业务
    handleCheckList() {
      if (this.checkList.indexOf(1) === -1) {
        this.checked = false;
      }
    },
    exportExcel() {
      var _this = this;
      if (!this.checked && !this.checkList.length) {
        this.$message.error("请勾选导出类型！");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.5)",
      });
      this.$q.newProduct
        .exportSpu({
          data: {
            exportTag: this.checked,
            filterData: {
              exportType: this.checkList,
              ...this.formData,
            },
            pageNum: 1,
            pageSIze: 100000,
          },
          // options: {
          //   responseType: 'blob'
          // }
        })
        .then((res) => {
          console.log(res);
          var timer = setInterval(function () {
            _this.$q.common
              .reportTaskInfo({ fragment: [res.message] })
              .then((res) => {
                console.log(res);
                if (res.data.taskStatus == "执行完成") {
                  clearInterval(timer);
                  loading.close();
                  _this.updateVal();
                  let filePath = JSON.parse(res.data.filePath);
                  _this.isShowExport = false;
                  filePath.forEach((data) => {
                    _this.downloadRes(data.filePath, data.fileName);
                  });
                }
              })
              .catch((err) => {
                this.$message.error(err.message);
              });
          }, 5000);
          // this.blobDownload(res, `新品进度更新${moment().format('YYYYMMDDHHmmss')}.xls`)
        })
        .finally((_) => {});
    },
    async downloadRes(url, fileName) {
      let response = await fetch(url, { mode: "cors" });
      let blob = await response.blob();
      let objectUrl = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = objectUrl;
      a.download = fileName + "" + url.substring(url.lastIndexOf("."));
      a.click();
      a.remove();
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-form-item
  margin-bottom 0
.tips
  font-size 14px
  color #E63946
  line-height 36px
</style>
